import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from '@/routes';
import { AreaSessionProvider } from '@/hooks/AreaSessionContext';

export function App(): JSX.Element {
  // AreaSessionProvider is INERT when VITE_ONBOARDING_RESUMABLE_ENABLED is
  // off (no Firebase import, no listeners) — the legacy wizard pays zero cost.
  return (
    <BrowserRouter>
      <AreaSessionProvider>
        <AppRoutes />
      </AreaSessionProvider>
    </BrowserRouter>
  );
}
